/* script */
//
//
//
//
//
//
//

// Components
import InputWithActions from 'shared/ui/components/form-components/InputWithActions.vue';

const __vue_script__ = {
    name: 'NewFormSection',

    components: { InputWithActions },

    props: {
        sections: {
            type: Array,
            default: () => []
        },

        editing: {
            type: Boolean,
            default: false
        },

        initialValue: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            ready: false,
            name: this.initialValue
        };
    },

    mounted() {
        this.ready = true;
        this.$nextTick(() => {
            this.$refs.form.$el.scrollIntoView();
        });
    },

    methods: {
        submit() {
            this.$emit('input', this.name);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "form",
    staticClass: "new-section-form",
    attrs: { slim: true, autocomplete: "off" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var handleSubmit = ref.handleSubmit
          return [
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.submit)
                  },
                },
              },
              [
                _c("validation-provider", {
                  attrs: {
                    rules: "required",
                    slim: true,
                    name: "section_name",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c(
                              "input-with-actions",
                              {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "registration.configuration.new_section_placeholder"
                                  ),
                                  type: "text",
                                  name: "name",
                                  errors: errors,
                                  focused: _vm.ready,
                                },
                                model: {
                                  value: _vm.name,
                                  callback: function ($$v) {
                                    _vm.name = $$v
                                  },
                                  expression: "name",
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("close")
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                                ),
                                _c(
                                  "button",
                                  { staticClass: "btn btn-success" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          _vm.editing
                                            ? "general.accept"
                                            : "general.create"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/registrations/NewFormSection.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__